/* eslint-disable max-len */
// @flow

import React, { Component } from 'react';
import { Link, Route, Switch, withRouter } from 'react-router-dom';

import { STATUS_SUCCESS } from 'constants/statusConstants';
import PageNotFound from 'components/app/PageNotFound';
import Loading from 'components/fragments/Loading';
import { WORLD_CUP_TYPE } from 'constants/matchsResultsConstant';
import competitionsInternationalesGroupContainer from 'containers/competitionsInternationales/competitionsInternationalesGroupContainer';
import competitionsInternationalesHomeContainer from 'containers/competitionsInternationales/competitionsInternationalesHomeContainer';
import competitionsInternationalesMatchsResults from 'containers/competitionsInternationales/competitionsInternationalesMatchsResultsContainer';
import competitionsInternationalesNewsContainer from 'containers/competitionsInternationales/competitionsInternationalesNewsContainer';
import competitionsInternationalesPlayerContainer from 'containers/competitionsInternationales/competitionsInternationalesPlayerContainer';
import competitionsInternationalesClassementContainer from 'containers/competitionsInternationales/competitionsInternationalesClassementContainer';
import competitionsInternationalesSingleMatch from 'containers/competitionsInternationales/competitionsInternationalesSingleMatchContainer';
import CompetitionsInternationalesDefaultHeader from 'containers/competitionsInternationales/CompetitionsInternationalesDefaultHeaderContainer';
import CompetitionsInternationalesMatchHeader from 'containers/competitionsInternationales/CompetitionsInternationalesMatchHeaderContainer';
import { withHelmet } from 'infrastructure/seo/Helmet';
import type { Status } from 'types/Status';
import type { CompetitionInternationale } from 'types/competitionsInternationales';

import './competitionsInternationales.css';
import './competitionsInternationalesGroupe.css';
import './conteneur-bleu.css';

export type StateProps = {
  data: CompetitionInternationale,
  status: Status
};

export type DispatchProps = {
  fetchCompetitionInternationale: (slug: string) => void
};

type Props = {
  match: any,
  history: any,
  location: any
} & StateProps &
  DispatchProps;

class CompetitionsInternationales extends Component<Props> {
  nav;
  history = [];

  componentDidMount() {
    if (!window.location.hash) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    const slug = this.props.match.params.competition;

    if (slug) {
      this.props.fetchCompetitionInternationale(slug);
    }

    if (this.nav) {
      const active = this.nav.getElementsByClassName('active').item(0);

      // $FlowFixMe
      if (active && typeof this.nav.scrollTo === 'function') {
        this.nav.scrollTo(active.offsetLeft, 0);
      }
    }
  }

  componentDidUpdate(prevProps) {
    const slug = this.props.match.params.competition;

    if (this.props.location.pathname !== prevProps.location.pathname) {
      if (this.props.history.action === 'PUSH') {
        this.history.push(this.props.location.pathname);
      } else if (this.props.history.action === 'POP') {
        this.history.pop();
      }

      const navBar = document.querySelector('nav.competitions-internationales-nav');
      if (navBar && !window.location.hash) {
        const { top } = navBar.getBoundingClientRect();
        const topPosition = top + window.scrollY;
        window.scrollTo({ top: topPosition, behavior: 'smooth' });
      }
    }

    // @TODO do not fetch if competition is already in the state
    if (slug && slug !== prevProps.match.params.competition) {
      this.props.fetchCompetitionInternationale(slug);
    }

    const currentPage = this.props.location.pathname.split('/')[3];
    const prevPage = prevProps.location.pathname.split('/')[3];
    if (
      (prevPage !== currentPage || this.props.status !== prevProps.status) &&
      this.nav &&
      this.props.status === STATUS_SUCCESS
    ) {
      const active = this.nav.getElementsByClassName('active').item(0);

      // $FlowFixMe
      if (active && typeof this.nav.scrollTo === 'function') {
        this.nav.scrollTo(active.offsetLeft, 0);
      }
    }
  }

  goBack = () => {
    if (this.history.length === 0) {
      this.props.history.replace('/');
    } else {
      this.props.history.goBack();
    }
  };

  render() {
    const {
      data,
      status,
      match: {
        path,
        params: { competition }
      },
      location
    } = this.props;

    if (status !== STATUS_SUCCESS) {
      return <Loading isBlue backgroundColor={'#013974'} />;
    }

    const splitedPath = location.pathname.split('/');
    const currentPage = splitedPath[3];
    const baseUrl = '/competitions-internationales/' + competition;

    return (
      <div className="container__competitions-internationales">
        <Switch>
          <Route
            exact
            path={path + '/matchs-et-resultats/:matchSlug'}
            render={props => <CompetitionsInternationalesMatchHeader goBack={this.goBack} {...props} />}
          />

          <Route render={props => <CompetitionsInternationalesDefaultHeader goBack={this.goBack} {...props} />} />
        </Switch>

        <nav className="competitions-internationales-nav" id="nav-competition">
          <ul ref={ref => (this.nav = ref)}>
            <li>
              <Link to={baseUrl} className={!currentPage ? 'active' : ''}>
                Accueil
              </Link>
            </li>

            <li>
              <Link
                to={baseUrl + '/matchs-et-resultats'}
                className={currentPage === 'matchs-et-resultats' ? 'active' : ''}
              >
                Matchs et Résultats
              </Link>
            </li>
            {WORLD_CUP_TYPE.includes(data.meta.competition_layout_type) && (
              <li>
                <Link to={baseUrl + '/classement'} className={currentPage === 'classement' ? 'active' : ''}>
                  Classement
                </Link>
              </li>
            )}
            <li>
              <Link to={baseUrl + '/actualites'} className={currentPage === 'actualites' ? 'active' : ''}>
                Actualités
              </Link>
            </li>

            <li>
              <Link to={baseUrl + '/le-groupe'} className={currentPage === 'le-groupe' ? 'active' : ''}>
                Le Groupe
              </Link>
            </li>
          </ul>
        </nav>

        <div className="container">
          {(!currentPage || (splitedPath.length === 4 && currentPage === 'matchs-et-resultats')) &&
            data.intro_page_evenementielle.title && (
              <section className="intro">
                <div className="section-container">
                  <div>
                    <h2>{data.intro_page_evenementielle.title}</h2>

                    <p>{data.intro_page_evenementielle.description}</p>
                  </div>

                  {/* {data.intro_page_evenementielle.imageSource && (
                  <img src={data.intro_page_evenementielle.imageSource} alt="" />
                )} */}

                  {data.intro_page_evenementielle.imageSource && (
                    <div
                      className="intro__image"
                      style={{ backgroundImage: 'url(' + data.intro_page_evenementielle.imageSource + ')' }}
                    />
                  )}
                </div>
              </section>
            )}

          <Switch>
            <Route exact path={path} component={competitionsInternationalesHomeContainer} />
            <Route exact path={path + '/le-groupe'} component={competitionsInternationalesGroupContainer} />
            <Route
              exact
              path={path + '/le-groupe/:joueurSlug'}
              component={competitionsInternationalesPlayerContainer}
            />
            <Route exact path={path + '/actualites'} component={competitionsInternationalesNewsContainer} />
            {((data.content_classement_competition &&
              data.content_classement_competition.phase_de_poule &&
              data.content_classement_competition.phase_de_poule.data &&
              data.content_classement_competition.phase_de_poule.data.length > 0) ||
              (data.content_classement_competition &&
                data.content_classement_competition.phase_finale &&
                data.content_classement_competition.phase_finale.data &&
                data.content_classement_competition.phase_finale.data.length > 0)) && (
              <Route exact path={path + '/classement'} component={competitionsInternationalesClassementContainer} />
            )}
            <Route exact path={path + '/matchs-et-resultats'} component={competitionsInternationalesMatchsResults} />

            <Route
              exact
              path={path + '/matchs-et-resultats/:matchSlug'}
              component={competitionsInternationalesSingleMatch}
            />

            <Route component={PageNotFound} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default withHelmet(withRouter(CompetitionsInternationales))((Helmet, pageProps: Props) => {
  const { data, status } = pageProps;

  if (status !== STATUS_SUCCESS || !data) {
    null;
  }

  const meta_title = `${data.title.raw} : Informations Officielles - FFR`;

  return (
    <Helmet htmlAttributes={{ lang: 'fr' }}>
      {meta_title && <title>{meta_title}</title>}
      {meta_title && <meta property={'og:title'} content={meta_title} />}
      <link rel={'canonical'} href={window.location.href} />

      {data.meta_description && <meta name={'description'} content={data.meta_description} />}
      {data.meta_description && <meta property={'og:description'} content={data.meta_description} />}

      {data.featured_media && data.featured_media.src && <meta property="og:image" content={data.featured_media.src} />}
    </Helmet>
  );
});
